import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_06 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '6' }));
  }, []);

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>
          주택임차차입금 원리금상환액 입력 상세 내역
        </p>
        <Table01
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('주택임차차입금') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>
          장기주택저당차입금 이자상환액 입력 상세 내역
        </p>
        <Table02
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('장기주택저당') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>주택마련저축 입력 상세 내역</p>
        <Table03
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('주택마련저축') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>월세액 입력 상세 내역</p>
        <Table04
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('월세액') != -1)}
        />
      </div>
    </div>
  );
};

export default NtsResult_06;

const Table01 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '15%', key: 'htmPerNm' },
    { name: '대상자 주민번호', width: '35%', key: 'htmRegNum' },
    { name: '사업자번호', width: '25%', key: 'htm003' },
    { name: '취급기관', width: '25%', key: 'htm004' },
  ];

  const headListGroup2 = [
    { name: '월', width: '15%', key: 'htmMm2' },
    { name: '대출계좌번호', width: '35%', dWidth: '50%', key: 'htm005' },
    { name: '대출일', width: '25%', key: 'htm007' },
    { name: '상환액계', width: '25%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '15%', key: 'htmPerNm' },
    { name: '대상자 주민번호', width: '37%', key: 'htmRegNum' },
    { name: '주택취득일', width: '23%', key: 'htm010' },
    { name: '취급기관', width: '25%', key: 'htm003' },
  ];

  const headListGroup2 = [
    { name: '월', width: '15%', key: 'htmMm2' },
    {
      name: '상환기간',
      width: '12%',
      key: 'htm012',
    },
    {
      name: '최초차입일 최종상환예정일',
      width: '25%',
      key: 'htmDate',
    },
    {
      name: '저당권설정일',
      width: '23%',
      key: 'htm011',
    },
    { name: '연간합계액', width: '25%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table03 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '15%', key: 'htmPerNm' },
    { name: '대상자 주민번호', width: '30%', key: 'htmRegNum' },
    { name: '월', width: '10%', key: 'htmMm2' },
    { name: '취급기관', width: '25%', key: 'htm004' },
    { name: '저축명', width: '20%', key: 'htm010' },
  ];

  const headListGroup2 = [
    {
      name: '저축구분',
      width: '15%',
      key: 'htm006',
    },
    {
      name: '계좌번호',
      width: '40%',
      key: 'htm003',
    },

    {
      name: '가입일',
      width: '25%',
      key: 'htm007',
    },
    { name: '납입금액', width: '20%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table04 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '13%', key: 'htmPerNm' },
    {
      name: '대상자 주민번호',
      width: '30%',
      key: 'htmRegNum',
    },
    {
      name: '임대인 성명',
      width: '15%',
      key: 'htm004',
    },
    {
      name: '주민등록번호',
      width: '22%',
      key: 'htm003',
    },
    {
      name: '유형',
      width: '20%',
      key: 'htm009',
    },
  ];

  const headListGroup2 = [
    { name: '계약 면적', width: '13%', key: 'htm008' },
    {
      name: '임대차 계약기간',
      width: '30%',
      key: 'htmDate',
    },
    {
      name: '계약서상 주소지',
      width: '37%',
      key: 'htm007',
    },
    { name: '납입금액', width: '20%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
